import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { map } from 'rxjs/operators';
import { BlockTimesProximityComponent } from '../block-times-proximity.component';
import { BlockTimesProximityActions } from './block-times-proximity.actions';

@Injectable()
export class BlockTimesProximityEffects {
    constructor(
        private actions$: Actions,
        private modalService: BsModalService) {
    }

    openPreviewEditTemplateDialog$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(BlockTimesProximityActions.openBlockTimesProximityDialogFromAngularJS),
                    map(({proximity, blockTimes}) => {
                        this.modalService
                            .show(BlockTimesProximityComponent,
                                {
                                    initialState: {
                                        blockTimes,
                                        proximity
                                    },
                                    backdrop: 'static',
                                    class: 'modal-lg-preview',
                                    keyboard: false // disable esc key

                                });
                    })),
        {dispatch: false}
    );
}
